var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftDestination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 405,
    viewBox: "0 0 138 405",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.114127 72.8345C38.7738 91.2838 65.0066 139.038 82.9519 178.161C100.318 216.02 80.1858 247.455 69.7134 287.768C58.3854 331.374 64.6848 377.385 22.0692 392.009C-18.7511 406.017 -24.2248 330.606 -63.7575 313.294C-97.8781 298.351 -166.67 328.902 -189.407 299.398C-218.077 262.194 -271.858 198.789 -261.982 152.871C-251.379 103.577 -167.561 131.26 -121.089 111.697C-76.7391 93.0273 -43.5894 52.2088 -0.114127 72.8345Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-7.67153 97.4936C23.0618 112.069 43.8035 149.777 57.9942 180.667C71.7267 210.561 55.8277 235.372 47.5638 267.194C38.6248 301.617 43.6152 337.942 9.94551 349.476C-22.3057 360.523 -26.6518 300.988 -57.8943 287.309C-84.8596 275.503 -139.209 299.603 -157.183 276.304C-179.848 246.925 -222.361 196.855 -214.57 160.606C-206.206 121.694 -139.967 143.572 -103.252 128.141C-68.213 113.414 -42.0303 81.1984 -7.67153 97.4936Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-6.6357 108.886C21.3557 122.166 40.2376 156.541 53.1542 184.702C65.6538 211.954 51.1624 234.582 43.6238 263.601C35.4694 294.991 40.0032 328.111 9.32821 338.638C-20.0545 348.722 -23.9936 294.439 -52.4492 281.977C-77.0091 271.222 -126.526 293.214 -142.892 271.976C-163.528 245.195 -202.239 199.555 -195.129 166.502C-187.497 131.018 -127.165 150.945 -93.714 136.862C-61.7908 123.422 -37.9291 94.0395 -6.6357 108.886Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-9.62983 122.792C14.7725 134.371 31.2306 164.348 42.4886 188.907C53.383 212.672 40.7464 232.408 34.1708 257.717C27.058 285.094 31.007 313.978 4.26237 323.162C-21.3556 331.96 -24.7838 284.619 -49.5909 273.754C-71.0018 264.377 -114.175 283.562 -128.44 265.042C-146.429 241.688 -180.173 201.889 -173.971 173.061C-167.314 142.115 -114.716 159.486 -85.5507 147.201C-57.7175 135.476 -36.9108 109.848 -9.62983 122.792Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-9.28588 131.35C12.963 141.908 27.9667 169.246 38.2295 191.643C48.161 213.317 36.6372 231.318 30.6394 254.4C24.1515 279.369 27.7497 305.712 3.36326 314.09C-19.9958 322.116 -23.1175 278.941 -45.7355 269.034C-65.257 260.483 -104.624 277.985 -117.629 261.095C-134.029 239.798 -164.794 203.503 -159.136 177.211C-153.063 148.986 -105.106 164.825 -78.5123 153.618C-53.1331 142.922 -34.1594 119.547 -9.28588 131.35Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-12.4705 157.527C3.18878 164.957 13.7502 184.194 20.9747 199.953C27.9659 215.203 19.857 227.868 15.6375 244.108C11.0733 261.675 13.6076 280.21 -3.55468 286.104C-19.9939 291.749 -22.1941 261.37 -38.1131 254.398C-51.8527 248.381 -79.5571 260.692 -88.7117 248.807C-100.255 233.821 -121.909 208.282 -117.93 189.784C-113.658 169.925 -86.5802 169.022 -67.8646 161.139C-50.0038 153.615 -29.977 149.221 -12.4705 157.527Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-14.7779 169.171C-2.18724 175.139 6.31629 190.566 12.1352 203.204C17.7663 215.433 15.0108 226.997 7.88241 238.591C4.75679 241.709 4.54552 242.325 -2.05659 244.58C-15.2633 249.091 -22.5066 252.396 -35.3056 246.795C-46.3524 241.96 -68.6069 251.805 -75.9737 242.272C-85.2631 230.25 -102.686 209.762 -99.5034 194.938C-96.0865 179.025 -74.3265 178.323 -59.2923 172.02C-44.9447 166.004 -28.8538 162.499 -14.7779 169.171Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-21.2935 179.892C-11.9723 184.298 -5.6504 195.629 -1.31951 204.909C2.87154 213.889 0.86153 222.362 -4.381 230.847C-6.68428 233.125 -6.83903 233.577 -11.7142 235.215C-21.4665 238.492 -26.8132 240.898 -36.2876 236.761C-44.4649 233.191 -60.893 240.358 -66.361 233.35C-73.2559 224.514 -86.1833 209.451 -83.8648 198.589C-81.3759 186.928 -65.2921 186.465 -54.1931 181.878C-43.601 177.5 -31.7143 174.967 -21.2935 179.892Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftDestination);
export default __webpack_public_path__ + "static/media/left-Destination.5bfe0ca52bd2ce07c9e00d03b73943e5.svg";
export { ForwardRef as ReactComponent };